import template from './billable_events.create.html'
import controller from './billable_events.create.controller'
import './billable_events.create.scss'

const billableEventsCreateComponent = {
    restrict: 'E',
    bindings: {
        acl: '=',
        hasACL: '='
    },
    template,
    controller
}

export default billableEventsCreateComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billable_events/create/billable_events.create.component.js